import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postContactList = async (listName, dynamicSettings) => {
  const apiURL = API_HOST + '/contact_lists';
  const { token, userID } = useCurrentUser();
  
  try {
    const { data } = await axios.post(apiURL,{
        contact_list:{
          list_name: listName,
          dynamic_settings: dynamicSettings
        }
    },{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer '+token,
        'x-sb-user-id': userID
      }
    });
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
